import axios from "axios";
import { API_URL } from "../../../Config";
import authHeader from "../../../Services/auth-header";

export const getVisitDepartmentByDate = async (data) => {
  const response = await axios.get(
    API_URL + "department-detail/visit-department-detail-stat",
    {
      headers: authHeader(),
      params: data,
    }
  );
  return response.data;
};
